import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { get } from 'lodash';
import type { DeleteAssetPlanMutation } from '#/graphql/types';
import { deleteAssetPlan as deleteAssetPlanMutation } from '#/graphql/mutations';

const q = gql(deleteAssetPlanMutation);

const useDeleteAssetPlanMutation = () => {
  const [mutation, result] = useMutation<DeleteAssetPlanMutation>(q);

  const deleteAssetPlan = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
      });

      return get(response, 'data.deleteAssetPlan.data', undefined);
    },
    [mutation],
  );

  return { deleteAssetPlan, result };
};

export default useDeleteAssetPlanMutation;
